module.exports = __webpack_public_path__ + "static/media/tona-google-play@3x.9b1b22a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/tona-google-play@3x.png
// module id = 762
// module chunks = 2